import React, { useEffect, useState } from "react";
import { Button, Layout, Space, Table, Tag, Typography, Alert, Row, Input, Col, Modal, Form, Card, Divider, Checkbox } from 'antd';
import { EyeOutlined, UsergroupAddOutlined, CaretLeftOutlined, CaretRightOutlined, LockOutlined, DeleteOutlined, CloseOutlined, WalletOutlined, EditOutlined } from '@ant-design/icons';
import { Link, useNavigate } from "react-router-dom";
import { inject, observer } from 'mobx-react'
import { cloneDeep } from "lodash";
import "./style.scss";
import Swal from "sweetalert2";

const { Content } = Layout;
const { Title, Text } = Typography;
const { Search } = Input;

const Admins = ({ userStore }) => {

  const navigate = useNavigate()
  const [form] = Form.useForm();
  const [formpermissions] = Form.useForm();

  const userType = "ADMIN";

  const [isEditAdmin, setIsEditAdmin] = useState(false);
  const [isEditPermissionAdmin, setIsEditPermissionAdmin] = useState(false);
  const [editableAdmin, setEditableAdmin] = useState();

  useEffect(() => {
    userStore.page = 1;
    userStore.hasMore = false;
    userStore.perPage = 10;
    userStore.fetchUsersAdmins(userType);
  }, []);

  const handlePrevPage = () => {
    userStore.page = userStore.page - 1;
    userStore.fetchUsersAdmins(userType);
  };

  const handleNextPage = () => {
    userStore.page = userStore.page + 1;
    userStore.fetchUsersAdmins(userType);
  };

  const onConfirmStatus = (id, userType) => {
    Swal.fire({
      title: "Deactivate Team Leader",
      icon: "question",
      text: "Are you sure do you want to deactivate team leader?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: `Cancel`,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        // function
      } 
    })
  };

  // const onConfirmDelete = (id) => {
  //   Swal.fire({
  //     title: "Delete Admin",
  //     icon: "question",
  //     text: "Are you sure do you want to delete team leader?",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: `Cancel`,
  //     allowOutsideClick: false,
  //     allowEscapeKey: false,
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       userStore.deleteTeamLeader(id).then(() => {
  //         userStore.fetchUsersAdmins(userType); // Refresh the list
  //       });
  //     } 
  //   })
  // };

  const onConfirmReset = (id) => {
    Swal.fire({
      title: "Reset Password",
      icon: "question",
      text: "Are you sure do you want to Reset Password?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: `Cancel`,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        userStore.resetPassword(id).then(() => {
          userStore.fetchUsersAdmins(userType); // Refresh the list
        });
      } 
    })
  };

  const formatNumber = (formatnumber) => {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(formatnumber);
  };

  const columns = [
    {
      title: 'Name',
      key: 'FullName+UserID',
      dataIndex: 'FullName',
      responsive: ['lg', 'xl', 'md'],
      render: (FullName) => (
        <Text default>{FullName}</Text>
      )
    },
    {
      title: 'Username',
      key: 'Username+UserID',
      dataIndex: 'Username',
      responsive: ['lg', 'xl', 'md'],
      render: (Username) => (
        <Text default>{Username}</Text>
      )
    },
    {
      title: 'Contact #',
      key: 'ContactNumber+UserID',
      dataIndex: 'ContactNumber',
      responsive: ['lg', 'xl', 'md'],
      render: (ContactNumber) => (
        <Text default>{ContactNumber}</Text>
      )
    },
    {
      title: 'Status',
      dataIndex: 'IsActive',
      key: 'IsActive+UserID',
      render: (IsActive) => (
        <Tag color={IsActive == 1 ? "green" : "red"}><Text type="primary" strong>{IsActive == 1 ? 'ACTIVE' : 'INACTIVE'}</Text></Tag>
      )
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      width: "350px",
      render: (text, record) => (
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <Space size={'small'}>
              <Link to={'/admins/'+record.UserID}><Button icon={<EyeOutlined/>} type="primary" ghost>View</Button></Link>
              <Button icon={<EditOutlined />} type="primary" ghost onClick={() => {
                setEditableAdmin(record);
                form.setFieldsValue({
                  FullName: record.FullName,
                  ContactNumber: record.ContactNumber,
                  Address: record.Address,
                  Remarks: record.Remarks
                });
                setIsEditAdmin(true);
              }}>Edit</Button>
            </Space>
          </Col>
          <Col span={24}>
            <Space size={'small'}>
              <Button icon={<UsergroupAddOutlined />} type="primary" ghost onClick={() => {

              const decodedString = decodeURIComponent(escape(atob(record.Permissions)));
              const permissions = JSON.parse(decodedString);

                setEditableAdmin(record);
                formpermissions.setFieldsValue({
                  // Ensure checkboxes are correctly set
                  addClusterLeaderCB: permissions.hasAddClusterLeader === "true", 
                  fundAllocationCB: permissions.hasfundAllocation === "true", 
                  eventsCB: permissions.hasEvents == "true",
                  organizationCB: permissions.hasOrganization == "true"
                });
                setIsEditPermissionAdmin(true);

              }}>Permissions</Button>
              <Button 
                fullWidth
                onClick={() => onConfirmReset(record.UserID)}
                loading={userStore.loading}
                danger
                icon={<LockOutlined />}
              >Reset Password</Button>
            </Space>
          </Col>
        </Row>
      )
    },
  ];

  const handleUpdateAdmin = (values) => {

    userStore.updateAdmin(values, editableAdmin.UserID).then(() => {
      setIsEditAdmin(false);
      userStore.fetchUsersAdmins(userType); // Refresh the list
    });
  };

  const handleUpdatePermissionAdmin = (values) => {

    userStore.updateAdminPermissions(values, editableAdmin.UserID).then(() => {
      setIsEditPermissionAdmin(false);
      userStore.fetchUsersAdmins(userType); // Refresh the list
    });
  };

  return (
    <div className="admin-list-team-leader">
      <Content>
        <div className="admin-content-team-leader">
          <Row justify={"space-between"} align={"middle"}>
            <Col>
              <Title level={4}>Admin List</Title>
            </Col>
            <Col>
              <Row gutter={10} align={"middle"}>
              </Row>
            </Col>
          </Row>
          <Alert
            message="List of Admins"
            description="List of your registered admins. If you think there's a problem with the list of users, please contact an administrator for assistance."
            type="info"
            showIcon
          />
          <div className="mobile-data">
            {(cloneDeep(userStore.admins) ?? []).map((admin) => (
              <Card 
                className="card-data"
                actions={[
                  <Link to={'/team-leaders/'+admin.UserID}><Button icon={<EyeOutlined />} type="primary" ghost style={{width: "95%"}}>View</Button></Link>,
                  <Link to={`/team-leaders/${admin.UserID}/edit`}><Button icon={<EditOutlined />} type="primary" ghost style={{width: "95%"}}>Edit</Button></Link>
                ]}
              >
                <Row gutter={10} align={"middle"}>
                  <Col>
                    <Text className="name-text" strong>{admin.FullName}</Text>
                  </Col>
                  <Col>
                    <Tag color={admin.IsActive == 1 ? "green" : "red"}>{admin.IsActive == 1 ? 'ACTIVE' : 'INACTIVE'}</Tag>
                  </Col>
                </Row>
                <Text type="secondary">{admin.ContactNumber}</Text>
                <Row gutter={10}>
                  <Text keyboard>Available Amount: {admin.Amount}</Text>
                </Row>
                <Divider/>
                <Row gutter={10} justify="center">
                  {/* <Col>
                    <Link to={`/team-leaders/${teamLeader.UserID}/edit`}><Button  icon={<EditOutlined />} type="primary" ghost /></Link>
                  </Col> */}
                  {/* <Col>
                    <Button 
                      onClick={() => onConfirmDelete(admin.UserID, admin.userType)}
                      loading={userStore.loading}
                      danger
                      icon={<DeleteOutlined />}
                    />
                  </Col> */}
                  <Col>
                    <Button 
                      onClick={() => onConfirmStatus(admin.userID, admin.userType)}
                      loading={userStore.loading}
                      danger
                      icon={<CloseOutlined />}
                      fullWidth
                    />
                  </Col>
                  <Col>
                    <Button 
                      fullWidth
                      onClick={() => onConfirmReset(admin.userID, admin.userType)}
                      loading={userStore.loading}
                      danger
                      icon={<LockOutlined />}
                    />
                  </Col>
                </Row>
              </Card>
              ))
            }
          </div>
          <div className="web-data">
            <Table pagination={false} columns={columns} dataSource={cloneDeep(userStore.admins)} bordered/>
          </div>
          <ul className="pagination">
            <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={userStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
            <li className="pagination-item"><a>{userStore.page}</a></li>
            <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={userStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
          </ul>
        </div>
        {/* EDIT BASIC DATA FROM TEAM LEADERS MODAL */}
        <Modal 
          title="Edit Admin Details" 
          open={isEditAdmin} 
          onCancel={() => setIsEditAdmin(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsEditAdmin(false)}>Cancel</Button>,
            <Button key="submit" type="primary" onClick={() => form.submit()}>Save Changes</Button>
          ]}
        >
          <Form
            name="editTeamLeaderData"
            layout="vertical"
            form={form} 
            onFinish={(values) => handleUpdateAdmin(values)}
          >
            <Form.Item label="Name" name="FullName" rules={[{ required: true, message: "Name is required" }]}>
              <Input placeholder="Enter Name" />
            </Form.Item>
            <Form.Item label="Address" name="Address" rules={[{ required: true, message: "Address is required" }]}>
              <Input placeholder="Enter Address" />
            </Form.Item>
            <Form.Item label="Contact Number" name="ContactNumber" rules={[{ required: true, message: "Contact number is required" }]}>
              <Input placeholder="Enter Contact Number" />
            </Form.Item>
            <Form.Item label="Remarks" name="Remarks" rules={[{ required: true, message: "Remarks is required" }]}>
              <Input.TextArea placeholder="Enter Remarks" />
            </Form.Item>
          </Form>
        </Modal>
        {/* EDIT PERMISSIONS FOR ADMIN */}
        <Modal 
          title="Edit Admin Permissions" 
          open={isEditPermissionAdmin} 
          onCancel={() => setIsEditPermissionAdmin(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsEditPermissionAdmin(false)}>Cancel</Button>,
            <Button key="submit" type="primary" onClick={() => formpermissions.submit()}>Save Changes</Button>
          ]}
        >
          <Form
            name="editTeamLeaderData"
            layout="vertical"
            form={formpermissions} 
            onFinish={(values) => handleUpdatePermissionAdmin(values)}
          >
            <Row>
              <Form.Item name="addClusterLeaderCB" valuePropName="checked">
                <Checkbox >Add District Coordinator</Checkbox>
              </Form.Item>
            </Row>
            <Row>
              <Form.Item name="fundAllocationCB" valuePropName="checked">
                <Checkbox >District Coordinator Fund Allocation</Checkbox>
              </Form.Item>
            </Row>
            <Row>
              <Form.Item name="eventsCB" valuePropName="checked">
                <Checkbox >Events (This includes Viewing of Events Data, Creating of Custom Events, Distribute Amount and Items)</Checkbox>
              </Form.Item>
            </Row>
            <Row>
              <Form.Item name="organizationCB" valuePropName="checked">
                <Checkbox >Organization (List of Organization from District Coor, Core Leader, Zone Leader and Recruits)</Checkbox>
              </Form.Item>
            </Row>
          </Form>
        </Modal>
      </Content>
    </div>

  );
};

export default inject('userStore')(observer(Admins));
